export const VISITOR_ACCESS_TYPE_PUBLIC = 'public'
export const VISITOR_ACCESS_TYPE_PRIVATE = 'private'
